<mat-toolbar color="accent">{{ data.title }}</mat-toolbar>

<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-dialog-content fxLayout="column">
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" [required]="true" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Merchant Id</mat-label>
      <input matInput type="number" formControlName="mid" [required]="true" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Terminal Id</mat-label>
      <input matInput type="number" formControlName="tid" [required]="true" />
    </mat-form-field>

    <pr-practitioner-selector
      label="Associated With"
      hint="If the Merchant ID is for a specific practitioner, select them here."
      allowEmpty
      [staffer]="
        !data.formData?.practitionerRef
          ? undefined
          : (data.formData?.practitionerRef
            | map: globalStore.getStaffer$ : globalStore
            | async)
      "
      (stafferSelected)="form.controls.practitionerRef.setValue($event?.ref)"
    />
  </mat-dialog-content>

  <mat-dialog-actions>
    <pt-buttons-container padding="none">
      <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary" [disabled]="form.invalid">
        Submit
      </button>
    </pt-buttons-container>
  </mat-dialog-actions>
</form>
